export const ERROR_CODE = {
  "90014": "유저 정보를 찾을 수 없습니다.",
  "31001": "비밀번호가 일치하지 않습니다.",
  "31002": "이미 가입된 이메일입니다.",
}
